/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-10-18 14:14:20
 * @LastEditors: linxi
 * @LastEditTime: 2025-04-03 17:37:36
 */


import { API_PREFIX } from './constant'
import { Request } from './request'

export interface TraceCodeFlowListParams {
  startDate?: any
  endDate?: any
  businessType ?: any
  medicalUploadStatus?: any
  isSplit?: any
  isRepeat?: any
}

export function TraceCodeFlowList(params: TraceCodeFlowListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/traceCode/getTraceCodeHistory`,
    method: 'GET',
    params,
  }
}


// 详情导出
export function getTraceCodeFlowExport(
  params: TraceCodeFlowListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/traceCode/getTraceCodeHistory/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params
  }
}
